import { useState } from "react";
import CategoriesFilter from "../components/news/CategoriesFilter";
import Dashboard from "../components/news/Dashboard";
import ManagePostLink from "../components/news/posts/parts/ManagePostLink";
import Title from "../components/Title";
import useLocalization from "../hooks/use-localization";
import '../resources/css/news-filter.css';
import '../resources/css/news.css';

export default function NewsPage() {

    const localization = useLocalization();
    const [selectedCategory, setSelectedCategory] = useState('all');

    return (
        <>
            <Title value={localization.news}></Title>

            <div className="news">
                <div className="news-content">

                    <ManagePostLink>{localization.createNewPost}</ManagePostLink>

                    <CategoriesFilter selected={selectedCategory} action={setSelectedCategory}></CategoriesFilter>

                    <Dashboard category={selectedCategory}></Dashboard>
                </div>
            </div>
        </>
    );
}